var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgObservation = function SvgObservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Observation_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "Observation_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 35.1c-.9 0-1.6-.3-2.2-.8-.6-.6-.9-1.3-.9-2.3 0-.9.3-1.6.9-2.2s1.3-.9 2.2-.9 1.6.3 2.2.9.9 1.3.9 2.2c0 1-.3 1.8-.9 2.3-.6.6-1.3.8-2.2.8M32 35.1c-.9 0-1.6-.3-2.2-.8-.6-.6-.9-1.3-.9-2.3 0-.9.3-1.6.9-2.2s1.3-.9 2.2-.9 1.6.3 2.2.9.9 1.3.9 2.2c0 1-.3 1.8-.9 2.3-.6.6-1.3.8-2.2.8M45.4 35.1c-.9 0-1.6-.3-2.2-.8-.6-.6-.9-1.3-.9-2.3 0-.9.3-1.6.9-2.2s1.3-.9 2.2-.9 1.6.3 2.2.9.9 1.3.9 2.2c0 1-.3 1.8-.9 2.3-.6.6-1.3.8-2.2.8",
    className: "Observation_svg__st0"
  })));
};
export default SvgObservation;